import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef,
  OnInit,
  ElementRef,
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours,
  
} from 'date-fns';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CalendarDateFormatter,
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
  DAYS_OF_WEEK,
} from 'angular-calendar';
import { CustomDateFormatter } from './custom-date-formatter.provider';

import { StorageService } from 'src/app/service/storage.service';
import { TutorService } from 'src/app/service/tutor.service';
import { ResponseAllTutorDisponibilidades, ResponseTutorDisponibilidad, ResponseTutorDisponibilidadObject, TutorDisponibilidad } from 'src/app/model/TutorDisponibilidad';
import { TutoriaService } from 'src/app/service/tutoria.service';


const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
  green: {
    primary: '#00b09e',
    secondary: '#EAFBF9',
  },
};


@Component({
  selector: 'app-disponibilidad',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './disponibilidad.component.html',
  styleUrls: ['./disponibilidad.component.css'],
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
  ],
})

export class DisponibilidadComponent{

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  @ViewChild('divSpinner') divSpinner:ElementRef;
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  locale: string = 'es-CL';
  weekStartsOn: number = DAYS_OF_WEEK.MONDAY;
  events: CalendarEvent[] = [];
  refresh = new Subject<void>();
  activeDayIsOpen: boolean = true;
  idTutor : number;
  cargando = true;

  constructor(
    private modal: NgbModal,
    private storageService: StorageService,
    private tutorService: TutorService) {}

  ngOnInit(): void {
    this.buscaTutor();
    this.cargaHorasTutor();
    
  }

  buscaTutor(){
    this.tutorService.API_POST_getIdTutorByIdUsuario(this.storageService.getCurrentUser().idUsuario).subscribe((response: ResponseTutorDisponibilidad) => {
      this.idTutor = response.payload;  
    },
    (err) => {
      console.log("error"+err)
    });
  }

 cargaHorasTutor(){
  this.tutorService.API_POST_getTutorDisponibilidadByIdUsuario(this.storageService.getCurrentUser().idUsuario).subscribe((response: ResponseAllTutorDisponibilidades) => {

    response.payload.forEach(function(entry) {
      
      let fechaInicio = new Date(entry.fechaInicio.toString());
      let fechaFin = new Date(entry.fechaFin.toString());

      fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
      fechaFin.setTime( fechaFin.getTime() + fechaFin.getTimezoneOffset()*60*1000 );

      let nombreJardin = "BRD : " + entry.rbdJardin + " Jardin : " + entry.nombreJardin;
      let calendarEvent: CalendarEvent = {
        id : entry.idTutorDisponibilidad,
        title: entry.idEstado === 145 ? 'Disponible' : nombreJardin,
        color: entry.idEstado === 145 ?  colors.green : colors.yellow,
        start: fechaInicio,
        end: fechaFin,
        draggable: false,
        actions:[
          // {
          //   label: '<i class="fas fa-fw fa-trash-alt"></i>',
          //   a11yLabel: 'Delete',
          //   onClick: ({ event }: { event: CalendarEvent }): void => {
          //     this.deleteTutoDisponibilidad(event.id);
          //     this.events = this.events.filter((iEvent) => iEvent !== event);
          //     //this.handleEvent('Deleted', event);
          //   },
          // }
        ]
      };
      this.events.push(calendarEvent);
      this.refresh.next();
    }, this);
    this.events = [...this.events];
    this.refresh;
    this.cargando = false;
  },
  (err) => {
    console.log("error"+err)
  })
 }

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  externalEvents: CalendarEvent[] = [
    this.createNewDisponibility()
  ];

  

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        console.log(event);
        this.events = this.events.filter((iEvent) => iEvent !== event);
        //this.handleEvent('Deleted', event);
      },
    },
  ];

  deleteTutoDisponibilidad(idTutorDisponibilidad:number){
    this.cargando = true;
    this.tutorService.API_DELETE_deleteTutorDisponibilidad(idTutorDisponibilidad).subscribe((response: any) => {     
      this.closeSpinner();
    },
    (err) => {

      console.log("error"+err)
    });

  }

  closeSpinner(){

    this.cargando = false;
    this.divSpinner.nativeElement.style.display='none';
  }


  

  

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  
  changeDay(date: Date) {
    this.cargando = true;
    this.viewDate = new Date(date);
    this.view = CalendarView.Week;
    this.cargando = false;
  }

  handleEvent(action: string, event: CalendarEvent): void {
    //this.modalData = { event, action };
    //this.modal.open(this.modalContent, { size: 'lg' });
  }

  addEvent(): void {
    this.events = [
      ...this.events,
      {
        title: 'New event',
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
        color: colors.red,
        draggable: true,
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
      },
    ];
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  eventDropped({
    event,
    newStart,
    newEnd,
    allDay,
  }: CalendarEventTimesChangedEvent): void {
    this.divSpinner.nativeElement.style.display='';
    const externalIndex = this.externalEvents.indexOf(event);
    if (typeof allDay !== 'undefined') {
      event.allDay = allDay;
    }
    if (externalIndex > -1) {
      this.externalEvents.splice(externalIndex, 1);
      this.externalEvents.push(this.createNewDisponibility());

      event.start = newStart;
      var fin : Date = new Date(newStart);
      fin.setHours(fin.getHours() + 2);
      event.end = fin;

      var tutorDisponibilidad = new TutorDisponibilidad();
      tutorDisponibilidad.idEstado = 1;
      tutorDisponibilidad.fechaInicio = event.start;
      tutorDisponibilidad.fechaFin = event.end;
      tutorDisponibilidad.idTutor = this.idTutor;
      this.tutorService.API_POST_guardarTutorDisponibilidad(tutorDisponibilidad).subscribe((response: ResponseTutorDisponibilidadObject) => {
        let calendarEvent: CalendarEvent = {
          id : response.payload.idTutorDisponibilidad,
          title: 'Disponible',
          color: colors.yellow,
          start: new Date(response.payload.fechaInicio),
          end: new Date(response.payload.fechaFin),
          draggable: false,
          actions:[
            {
              label: '<i class="fas fa-fw fa-trash-alt"></i>',
              a11yLabel: 'Delete',
              onClick: ({ event }: { event: CalendarEvent }): void => {
                this.deleteTutoDisponibilidad(response.payload.idTutorDisponibilidad);
                this.events = this.events.filter((iEvent) => iEvent !== event);
                //this.handleEvent('Deleted', event);
              },
            }
          ]
        };
        this.events.push(calendarEvent);
        this.divSpinner.nativeElement.style.display='none';
        this.events = [...this.events];
        this.refresh.next();
      },
      (err) => {
        console.log("error"+err)
      })

      
    }
    
    if (this.view === 'month') {
      this.viewDate = newStart;
      this.activeDayIsOpen = true;
    }
   
   
  }


  externalDrop(event: CalendarEvent) {
    if (this.externalEvents.indexOf(event) === -1) {
      this.events = this.events.filter((iEvent) => iEvent !== event);
      this.externalEvents.push(event);
    }
  }


  createNewDisponibility():CalendarEvent{
    const calendarEvent: CalendarEvent = {
      title: 'Disponible',
      color: colors.yellow,
      start: new Date(),
      draggable: true,
      actions:[
        {
          label: '<i class="fas fa-fw fa-trash-alt"></i>',
          a11yLabel: 'Delete',
          onClick: ({ event }: { event: CalendarEvent }): void => {
            this.events = this.events.filter((iEvent) => iEvent !== event);
            this.handleEvent('Deleted', event);
          },
        }
      ]
    }
 
    return calendarEvent;
  }

}
